import Link from 'next/link';
import { BlurInH2 } from '../eldora-ui/blur-in-h2';
import { getSanityImageUrl } from '@/libs/sanity/client';
import Image from 'next/image';
import { HiOutlineArrowCircleRight } from 'react-icons/hi';

export type RelatedArticleProps = {
  newsAndEvents: any[];
};

const RelatedArticle = ({ newsAndEvents }: RelatedArticleProps) => (
  <>
    <BlurInH2>What&#39;s New</BlurInH2>
    <ul className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-x-2 lg:gap-x-6">
      {newsAndEvents.map(({ _id, metadata, image, title }) => (
        <li key={_id} className="w-full border border-gray-200 bg-lightGray">
          <Link href={metadata.slug.current} className="grid grid-rows-12">
            {image ? (
              <Image
                className="w-full h-[250px] object-cover row-span-6"
                src={getSanityImageUrl(image)}
                alt={title}
                width="475"
                height="250"
              />
            ) : (
              <div className="w-full h-[250px] bg-base-200 row-span-6"></div>
            )}
            <div className="flex flex-col justify-between row-span-6 px-6 mt-6">
              <h5 className="text-lg font-normal">{title}</h5>
              <HiOutlineArrowCircleRight
                className="text-primary text-sm xl:text-lg font-regular mb-6"
                size="26"
              />
            </div>
          </Link>
        </li>
      ))}
    </ul>
  </>
);

export default RelatedArticle;
